import { BaseApi, RequestHeaders } from '@bv/api/base';

import type { Wallet } from '@/types/api/cloud-lines/wallet';

class WalletApi extends BaseApi {
  constructor(public endpoint = 'cloud-lines/wallet') {
    super(endpoint);
  }

  public async getBalance({ headers }: { headers?: RequestHeaders } = {}): Promise<Wallet> {
    return this.request({
      method: 'get',
      url: 'balance',
      headers,
    }).then((res) => res.data);
  }
}

export const walletApi = new WalletApi();
